export const MENU_PROPERTIES_1 = [
  { value: 0, key: '全て表示' }, //all
  { value: 1, key: 'ランチ' }, //lunch
  { value: 2, key: '定食' }, // set meal
  { value: 3, key: '年齢制限' }, //age limit
];

export const MENU_PROPERTIES_2 = [
  { value: 4, key: '店員呼出' }, //clerk call
  { value: 5, key: 'クーポン' }, //coupon
  { value: 6, key: 'サービス' }, //service
  { value: 7, key: '提供タイミング' }, //service
  { value: 8, key: '終売' }, //eos
];

export const MENU_TYPES = [
  { value: 0, key: '全て表示', display_name: '全て表示' },
  { value: 1, key: '通常メニューのみ表示', display_name: '通常' },
  { value: 2, key: 'サブメニューのみ表示', display_name: 'サブ' },
];

export const SEARCH_MENU_TYPE_CONDITIONS = [
  { value: 0, key: '　サブメニュー非表示', display_name: '　サブメニュー非表示' },
  { value: 1, key: '　サブメニュー含めて表示', display_name: '　サブメニュー含めて表示' },
  { value: 2, key: '　サブメニューのみ表示', display_name: '　サブメニューのみ表示' },
];

export const DISPLAY_LIMIT = [
  { value: 1, key: 'あり（100件のみ表示）' },
  { value: 2, key: 'なし' },
];

export const MENU_DELETE_OPTIONS = [
  { value: 0, key: '削除データ非表示' },
  { value: 1, key: '削除データ含めて表示' },
  { value: 2, key: '削除データのみ表示' },
];

export const MENU_DISPLAY_TIMING = [
  { value: 1, key: '常時' },
  { value: 2, key: 'ランチオーダー時' },
  { value: 3, key: '定食オーダー時' },
  { value: 4, key: 'ランチ時間帯のみ' },
  { value: 5, key: 'ランチ時間帯以外' },
  { value: 6, key: '表示制御グループ' },
];

export const MENU_DISPLAY_TIMING_SUB = [{ value: 1, key: '常時' }];

export const COUPON_CLASSIFICATIONS = ['U', 'C', 'T'];

export const MAIN_MENU = 1;
export const SUB_MENU = 2;
export const MENU_DEFAULT = 0;

export const MENU_PROPERTIES = [...MENU_PROPERTIES_1, ...MENU_PROPERTIES_2];

export type DisplayControlGroupType = {
  value: number;
  key: string;
  display_name: string;
};
